<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <LhinsStatusProgress :height="300" :data=ni titre="Non-Identifiés"></LhinsStatusProgress>
      </div>
      <div class="col-sm-6">
        <LhinsStatusProgress :height="300" :data=id titre="Identifiés/Désignés"></LhinsStatusProgress>
      </div>
      <div class="col-sm-12">
        <TableauSoumission :data="plusOntario"></TableauSoumission>
      </div>
    </div>
  </div>
</template>

<script>
import LhinsStatusProgress from '@/components/LhinsStatusProgress.vue'
import TableauSoumission from '@/components/TableauSoumission.vue'
import axios from 'axios';

export default {
  data: function() {return {
    soumissions: {par_rliss: []},
  }},

  name: 'SoumissionRliss',
  components: {
    LhinsStatusProgress,
    TableauSoumission
  },
  computed: {
    ni() {
      return this.soumissions.par_rliss.map(x => ({
          label: x.rliss_fr,
          dev: (100 * x.niDev / x.niTotal).toFixed(1),
          soumis: (100 * x.niSoumis / x.niTotal).toFixed(1),
          evalue: (100 * x.niEvalue / x.niTotal).toFixed(1),
          devAbs: x.niDev,
          soumisAbs: x.niSoumis,
          evalueAbs: x.niEvalue,
      }));
    },
    id() {
      return this.soumissions.par_rliss.map(x => ({
          label: x.rliss_fr,

          dev: (100 * x.idDev / x.idTotal).toFixed(1),
          soumis: (100 * x.idSoumis / x.idTotal).toFixed(1),
          evalue: (100 * x.idEvalue / x.idTotal).toFixed(1),
          devAbs: x.idDev,
          soumisAbs: x.idSoumis,
          evalueAbs: x.idEvalue
      }));
    },
    plusOntario() {
      if(this.soumissions.par_rliss.length == 0)
        return this.soumissions.par_rliss;
      var arr = this.soumissions.par_rliss.slice();
      const ont = this.soumissions.par_rliss.reduce((a, b) => ({
          rliss_fr: "Ontario",
          rliss_en: "Ontario",
          niDev: a.niDev + b.niDev,
          niSoumis: a.niSoumis + b.niSoumis,
          niEvalue: a.niEvalue + b.niEvalue,
          niTotal: a.niTotal + b.niTotal,
          idDev: a.idDev + b.idDev,
          idSoumis: a.idSoumis + b.idSoumis,
          idEvalue: a.idEvalue + b.idEvalue,
          idTotal: a.idTotal + b.idTotal,
      }));
      arr.unshift(ont);
      return arr;

    },

  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/soumission_par_region.php',
            {
              // headers: {X-Custom-AuthorizationAuthorization: "Bearer " + 'test' }
              // headers: {"X-Custom-Authorization": 'test' }
              // withCredentials: true,
            }
          )
        .then(response => (this.soumissions = response.data))

    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style>
</style>
